import type { inferRouterInputs } from '@trpc/server'
import type { AppRouter } from '@viapeople/api'
import type { Connection, Edge, Node } from '@xyflow/react'

export enum StepType {
	CYCLE_START = 'cycle_start',
	EDIT_REVIEWERS_LIST = 'edit_rater_list',
	APPROVE_REVIEWERS_LIST = 'approve_rater_list',
	SELF_EVALUATION = 'self_evaluation',
	GROUP_EVALUATION = 'group_evaluation',
	MANAGER_EVALUATION = 'manager_evaluation',
	UNSOLICITED_EVALUATION = 'unsolicited_evaluation',
	DIRECT_REPORTS_EVALUATION = 'direct_reports_evaluation',
	PEER_EVALUATION = 'peer_evaluation',
	DOWN_EVALUATION = 'down_evaluation',
	UP_EVALUATION = 'up_evaluation',
	CALIBRATION = 'calibration',
	REVIEW = 'review',
	RELEASE = 'release',
	ACKNOWLEDGE = 'acknowledge',
	EMAIL = 'email',
	HOLD = 'hold',
	CYCLE_END = 'cycle_end',
}

export enum HoldEditorEnum {
	SELF = 'self',
	MANAGER = 'mgr',
	CYCLE_ADMIN = 'ca',
}

export enum RaterListApproverEnum {
	MANAGER = 'manager',
	CYCLE_ADMIN = 'ca',
}

type RouterInput = inferRouterInputs<AppRouter>
type UpdateNodeInput = RouterInput['admin']['cycles']['steps']['diagram']['edit']['nodes'][number]
export type CycleStepFormData = NonNullable<UpdateNodeInput['data']['options']>

export interface NodeData {
	label: string
	stepType?: StepType
	onEdit?: (id: string) => void
	onDelete?: (id: string) => void
	onSelect?: (id: string) => void
	isFixed?: boolean
	options?: CycleStepFormData
	[key: string]: unknown
}

export interface EdgeData {
	label?: string
	key?: string
	movesForward?: boolean
	allowedNextSteps?: string[] | null
	onDelete: (id: string) => void
	description?: string
	sourceHandle?: string
	targetHandle?: string
	[key: string]: unknown
}

export interface ExtendedConnection extends Connection {
	data?: {
		label?: string
		movesForward?: boolean
	}
}

export type CustomNode = Node<NodeData, string>

export type CustomEdge = Edge<EdgeData>
